<template>
  <div class="checkout-page">
    <Checkout />
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Checkout from '../components/Checkout/Index';

export default {
  components: { Checkout },
  mixins: [global],
  async beforeRouteLeave(to, from, next) {
    if (this.$store.state.checkout.currentTab === 'account') {
      await this.$store.dispatch('checkout/setPaymentCart', {
        type: 'no-user',
        email: this.$store.state.checkout.account.email,
        firstName: this.$store.state.checkout.account.firstName,
        lastName: this.$store.state.checkout.account.lastName,
      });
    } else if (this.$store.state.checkout.currentTab === 'payment') {
      await this.$store.dispatch('checkout/setPaymentCart', {
        type: this.$store.state.checkout.order.upgrade ? 'upgrade' : 'new-subscription',
      });
    }

    if (['/start-learning/', '/resources-center/offer/'].includes(to.path)) {
      window.location.href = to.path;
      return true;
    }

    return next();
  },
  async asyncData({
    $axios, $config, store, route, redirect,
  }) {
    if (!route.query.plan && !route.query.course) {
      return redirect('/pricing/');
    }

    if (route.query.plan === 'coins') {
      return redirect('/pricing/');
    }

    if (route.query.msg && route.query.msg === 'successful' && store.getters['auth/user'].id) {
      if (route.query.plan === 'coins') {
        return redirect(`${$config.lmsUrl}/coins/`);
      }

      return redirect(`${$config.lmsUrl}/thank-you/?subscribe=true`);
    }

    let quantity = +route.query.quantity || 1;
    if (quantity > 30 && route.query.plan !== 'coins') {
      quantity = 30;
    } else if (quantity < 2 && route.query.plan !== 'coins') {
      quantity = 2;
    }

    store.commit('checkout/setQuantity', { quantity, input: true });

    const {
      plan, coupon, rkey, promo, page, ptype,
    } = route.query;
    await store.dispatch('checkout/fetchOrderSummary', {
      plan, coupon, rkey, promo, page, ptype,
    });

    if (process.server) {
      const { order } = store.state.checkout;
      if (!order.preview) {
        if (order.type === 'downgrade') {
          return redirect(`/pricing/?alert=${order.type}`);
        }

        if (order.type === 'extend-no-better-price') {
          return redirect(`/pricing/?alert=${order.type}&currentPlan=${route.query.plan}`);
        }

        if (order.type === 'course-purchased') {
          return redirect(`/pricing/?alert=${order.type}`);
        }

        if (order.existingLifetime) {
          return redirect('/pricing/?alert=existing-lifetime');
        }

        if (order.lifetime) {
          return redirect('/pricing/?alert=lifetime');
        }

        if (order.notChargify) {
          return redirect('/pricing/?alert=fs-not-allowed');
        }

        if (order.invalidEmail) {
          return redirect('/pricing/?alert=invalid-email');
        }

        if (order.redirect) {
          return redirect(`/checkout/?plan=${order.redirect}`);
        }

        return redirect('/pricing/');
      }

      if (order.invalidKey) {
        return redirect('/checkout/?plan=annual');
      }
    }

    const pageMeta = await $axios.$get(`/pages/${route.fullPath}`).catch(() => false);

    return { page: pageMeta };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: 'Checkout%s',
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps({ ...this.page, robots: 'noindex, nofollow' }),
      script: [
        { src: 'https://js.chargify.com/latest/chargify.js', async: true, type: 'text/javascript' },
        linkedData,
      ],
    };
  },
  async created() {
    if (this.$route.query.msg && process.client) {
      this.$store.dispatch('modals/open', { name: 'payment-taking-longer' });
    }

    /**
     * Track Linkedin signup event
     */
    const { signupType, formType } = this.$route.query;
    const { user } = this.$store.state.auth || {};
    if (user && signupType === 'linkedin') {
      // this.$gtag.set({
      //   referrer: this.$config.siteUrl,
      // });

      // Track Linkedin first signup event
      if (formType === 'signup' && user.registered) {
        this.$tracking.setSignupEvent({ signupType: 'Linkedin', directSend: true, userId: user.id });
      }

      // Remove additional params signupType and formType from URL when done with tracking
      // to avoid tracking the same event multiple times
      this.$router.push({ path: '/checkout/', query: { ...this.$route.query, formType: undefined, signupType: undefined } });
    }
  },
  mounted() {
    this.$tracking.analytics().track('page_checkout_visited', { origin: (this.$store.state.referrer || '').includes('learn') ? 'lms' : 'front' });
  },
};
</script>

<style lang="scss" scoped>
.checkout-page {
  padding-top: var(--spacing-80);
  padding-bottom: var(--spacing-80);
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: var(--main-dark-shade-1);
}

@include bp($bp-mobile) {
  .checkout-page {
    padding-bottom: 0;
  }
}

.fa {
  .checkout-page {
    background: var(--main-dark);

    ::v-deep {
      .checkout {
        .steps-holder {
          .payment-form-loader {
            background: var(--main-dark);
          }
        }
      }
    }
  }
}
</style>
